import request from '@/utils/request';

/**
 * 获取当前用户的完整信息（个人中心使用）
 */
export function getCurrentUserProfile() {
  return request({
    url: '/auth/profile',
    method: 'get',
  });
}

/**
 * 更新当前用户信息（个人中心使用）
 */
export function updateUserProfile(data) {
  return request({
    url: '/auth/update-profile',
    method: 'post',
    data,
  });
}

/**
 * 更新当前用户密码（个人中心使用）
 */
export function updateUserPassword(data) {
  return request({
    url: '/auth/update-password',
    method: 'post',
    data,
  });
}


/**
 * 获取用户列表
 */
export function getUserList(params) {
  return request({
    url: '/rbac/users',
    method: 'get',
    params,
  });
}

/**
 * 创建用户
 */
export function createUser(data) {
  return request({
    url: '/rbac/users',
    method: 'post',
    data,
  });
}

/**
 * 根据手机号获取企业微信userid
 */
export function getWechatUserIdFromMobile(mobile) {
  return request({
    url: '/rbac/third_api/wechat_userid_from_mobile',
    method: 'get',
    params: { mobile },
  });
}



/**
 * 更新用户
 */
export function updateUser(id, data) {
  return request({
    url: `/rbac/users/${id}`,
    method: 'put',
    data,
  });
}

/**
 * 删除用户
 */
export function deleteUser(id) {
  return request({
    url: `/rbac/users/${id}`,
    method: 'delete',
  });
}

/**
 * 获取用户详情（管理员用）
 */
export function getUserDetail(id) {
  return request({
    url: `/rbac/users/${id}`,
    method: 'get',
  });
}


/**
 * 获取指定角色的用户列表
 */
export function getUsersWithRole(roleCode) {
  return request({
    url: `/rbac/users/${roleCode}/users`,
    method: 'get',
  });
}
